module.exports = __webpack_public_path__ + "static/media/punctuation_img.8ab71764.JPG";